import React, { Component } from 'react'
import { Container, Table, Button, Form, Modal, Col, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { NavBar,AdminNav } from '../../helpers'
import TextInput from 'react-autocomplete-input';

class EditCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Company: {},
      target: '',
      targetObj: '',
      modalShow: false,
      companyData: {}
    }
  }

  componentWillMount() {
    console.log(this.props?.location?.state)
    this.setState({
      ...this.state,
      Company: this.props?.location?.state
    })
  }
  handleEdiCompany(data) {
    console.log(data)
    let c = axios.post(
      'https://backend1.riceinspections.com/testEA',
      { data: data }
    )
      .then((res) => {
        alert('บันทึกเรียบร้อยแล้ว')
      }).catch((err) => {
        alert('เกิดข้อผิดพลาด')
      })
  }
  handleChangeCompany(e, objName, fieldName) {
    this.setState({
      ...this.state,
      Company: {
        ...this.state.Company,
        [objName]: {
          ...this.state.Company[objName],
          [fieldName]: e
        }
      }
    })
  }
  renderCompany(company) {
    if (company) {
      return (
        Object.keys(company).map((a, idx) => {
          return <tr>
            <td>
              <Form.Group as={Col}>
                <TextInput Component='input'
                  regex={''} spacer={''} maxOptions={10}
                  value={company[a]['companyNameTH']}
                  onChange={(e) => { this.handleChangeCompany(e, a, 'companyNameTH') }}
                  className='form-control' trigger={''} />
              </Form.Group>
            </td>
            <td>
              <Form.Group as={Col}>
                <TextInput Component='input'
                  regex={''} spacer={''} maxOptions={10}
                  value={company[a]['companyNameEN']}
                  onChange={(e) => { this.handleChangeCompany(e, a, 'companyNameEN') }}
                  className='form-control' trigger={''} />
              </Form.Group>
            </td>
            <td>
              <Form.Group as={Col}>
                <TextInput Component='input'
                  regex={''} spacer={''} maxOptions={10}
                  value={company[a]['companyNameENFull']}
                  onChange={(e) => { this.handleChangeCompany(e, a, 'companyNameENFull') }}
                  className='form-control' trigger={''} />
              </Form.Group>
            </td>
          </tr>
        })
      )
    }
  }
  render() {
    let modalClose = () => this.setState({ modalShow: false });
    return (
      <Container>
        <AdminNav></AdminNav>
        <NavBar />
        <Navbar style={{ backgroundColor: '#F5F5F5' }} sticky="top" >
          <Container>
            <Navbar.Brand href="#">{} </Navbar.Brand>
            <Button onClick={() => { this.handleEdiCompany(this.state.Company) }}> save </Button>
          </Container>
        </Navbar>

        <Table bordered hover>
          <thead>
            {<tr><th>ชื่อบริษัทภาษาไทย</th><th>ชื่อบริษัทภาษาอังกฤษ</th><th>ชื่อบริษัทภาษาอังกฤษ (หนังสือรับรอง)</th></tr>}
          </thead>
          <tbody>
            {this.renderCompany(this.state.Company)}
          </tbody>
        </Table>
      </Container> 
    )
  }
}

export default EditCompany;
